import { Routes } from '@angular/router';
import {LayoutComponent} from "../components/shared/layout/layout.component";
import {PageComponent} from "../components/pages/page/page.component";
import {FicheComponent} from "../components/pages/fiche/fiche.component";
import {SelectionComponent} from "../components/pages/selection/selection.component";

const defaultData =  {
  revalidate: 86400
};
export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'selection/:slug',
        component: SelectionComponent,
        data: defaultData,
      },
      {
        path: 'fiche/:slug',
        component: FicheComponent,
        data: defaultData,
      },
      {
        path: ':slug0/:slug1/:slug3/:slug4/:slug5/:slug6',
        component: PageComponent,
        data: defaultData,
      },
      {
        path: ':slug0/:slug1/:slug2/:slug3/:slug4',
        component: PageComponent,
        data: defaultData,
      },
      {
        path: ':slug0/:slug1/:slug2/:slug3',
        component: PageComponent,
        data: defaultData,
      },
      {
        path: ':slug0/:slug1/:slug2',
        component: PageComponent,
        data: defaultData,
      },
      {
        path: ':slug0/:slug1',
        component: PageComponent,
        data: defaultData,
      },
      {
        path: ':slug0',
        component: PageComponent,
        data: defaultData,
      },
      {
        path: '',
        component: PageComponent,
        data : defaultData
      }
    ]
  }
];
